"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGranteeItemTestId = exports.getAppliedGrantees = exports.hasGroupAll = exports.notInArrayFilter = exports.sortGranteeList = exports.sortGranteesByName = exports.getGranteeLabel = exports.InactiveOwner = exports.INACTIVE_OWNER_ID = exports.GranteeGroupAll = exports.GROUP_ALL_ID = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var types_1 = require("./types");
var differenceWith_1 = tslib_1.__importDefault(require("lodash/differenceWith"));
var partition_1 = tslib_1.__importDefault(require("lodash/partition"));
/**
 * @internal
 */
exports.GROUP_ALL_ID = "groupAll";
/**
 * @internal
 */
exports.GranteeGroupAll = {
    id: sdk_model_1.uriRef(exports.GROUP_ALL_ID),
    type: "groupAll",
};
/**
 * @internal
 */
exports.INACTIVE_OWNER_ID = "inactive_owner";
/**
 * @internal
 */
exports.InactiveOwner = {
    id: sdk_model_1.uriRef(exports.INACTIVE_OWNER_ID),
    type: "inactive_owner",
};
/**
 * @internal
 */
var exhaustiveCheck = function (_param) {
    throw new Error("unknown grantee type");
};
/**
 * @internal
 */
exports.getGranteeLabel = function (grantee, intl) {
    if (grantee.type === "user") {
        if (grantee.isCurrentUser) {
            return intl.formatMessage({ id: "shareDialog.share.grantee.item.you" }, { userName: grantee.name });
        }
        return grantee.name;
    }
    else if (grantee.type === "group") {
        return grantee.name;
    }
    else if (grantee.type === "groupAll") {
        return intl.formatMessage({ id: "shareDialog.share.grantee.item.user.all" });
    }
    else if (grantee.type === "inactive_owner") {
        return intl.formatMessage({ id: "shareDialog.share.grantee.item.user.inactive" });
    }
    else {
        exhaustiveCheck(grantee);
    }
};
/**
 * @internal
 */
exports.sortGranteesByName = function (intl) {
    return function (granteeA, granteeB) {
        var textA = exports.getGranteeLabel(granteeA, intl).toUpperCase();
        var textB = exports.getGranteeLabel(granteeB, intl).toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    };
};
exports.sortGranteeList = function (grantees, intl) {
    var granteeSort = exports.sortGranteesByName(intl);
    var hasAllGroup = exports.hasGroupAll(grantees);
    var granteesWithNoAllGroup = grantees.filter(function (g) { return !types_1.isGranteeGroupAll(g); });
    var _a = tslib_1.__read(partition_1.default(granteesWithNoAllGroup, types_1.isGranteeGroup), 2), groups = _a[0], users = _a[1];
    var sorted = tslib_1.__spread(groups.sort(granteeSort), users.sort(granteeSort));
    if (hasAllGroup) {
        return tslib_1.__spread([exports.GranteeGroupAll], sorted);
    }
    return sorted;
};
/**
 * @internal
 */
exports.notInArrayFilter = function (array, notInArray) {
    return differenceWith_1.default(array, notInArray, function (g, g1) { return sdk_model_1.areObjRefsEqual(g.id, g1.id); });
};
/**
 * @internal
 */
exports.hasGroupAll = function (array) {
    return array.some(function (g) { return sdk_model_1.areObjRefsEqual(g.id, exports.GranteeGroupAll.id); });
};
/**
 * @internal
 */
exports.getAppliedGrantees = function (grantees, granteesToAdd, granteesToDelete) {
    var omitDeleted = exports.notInArrayFilter(grantees, granteesToDelete);
    return tslib_1.__spread(omitDeleted, granteesToAdd);
};
/**
 * @internal
 */
exports.getGranteeItemTestId = function (grantee, prefix) {
    var prefixValue = prefix ? prefix + "-" : "";
    var id = sdk_model_1.objRefToString(grantee.id).split("/").pop();
    return "s-gd-grantee-item-id-" + prefixValue + id;
};
//# sourceMappingURL=utils.js.map